import { render } from "./intersect.vue?vue&type=template&id=4105ed2f"
import script from "./intersect.vue?vue&type=script&lang=ts"
export * from "./intersect.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4105ed2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4105ed2f', script)) {
    api.reload('4105ed2f', script)
  }
  
  module.hot.accept("./intersect.vue?vue&type=template&id=4105ed2f", () => {
    api.rerender('4105ed2f', render)
  })

}

script.__file = "resources/js/components/ui/intersect.vue"

export default script